import { MessageBox, ProgressBar } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import { ActionProgressContainerProps } from './ActionProgressContainer';

const messages = defineMessages({
  cancel: {
    id: 'ui.button.cancel',
    defaultMessage: 'Cancel',
  },
  cancelling: {
    id: 'core.actionProgress.cancelling',
    defaultMessage: 'Cancelling...',
  },
});

const useStyles = createUseStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    padding: '16px 16px 8px',
  },
  label: {
    textAlign: 'right',
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
  },
});

const ActionProgress = ({
  progress,
  onCancel,
}: ActionProgressContainerProps): React.JSX.Element | null => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  if (!progress?.visible) return null;

  return (
    <MessageBox open title={progress.actionName}>
      <MessageBox.Content>
        <div className={classes.content}>
          <ProgressBar
            className={classes.progressBar}
            value={progress.progress}
          />
          <div className={classes.label}>
            {progress.message ?? `${progress.progress}%`}
          </div>
        </div>
      </MessageBox.Content>
      {progress.cancellable && (
        <MessageBox.Footer>
          <MessageBox.Button
            label={formatMessage(
              progress.cancelling ? messages.cancelling : messages.cancel
            )}
            disabled={progress.cancelling}
            onClick={() => onCancel()}
          />
        </MessageBox.Footer>
      )}
    </MessageBox>
  );
};

export default ActionProgress;
